import OrganizationUsersIndexPage from "./OrganizationUsersIndexPage";
export default OrganizationUsersIndexPage;
